<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'编辑培训推荐':'新增培训推荐'" :visible.sync="dialog" @close="unShowClick()" width="30%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="选择培训" prop="uuid" :label-width="formLabelWidth" v-if="activeName == 'zh'">
					<el-select style="width: 100%;" v-model="addBody.uuid" placeholder="请选择培训">
						<el-option v-for="item in trainList" :label="item.name" :value="item.uuid"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getTrainList,
		addTrainRecommend,
	} from "@/api/train"
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				trainList: [],
				addBody: {
					uuid: '',
					is_recommend:1
				},
				images: [],
				roleUuid: "",
				rules: {
					uuid: [{
						required: true,
						message: '请选择培训',
						trigger: 'change'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
			}
		},
		mounted() {},
		methods: {
			async getTrainList() {
				let postData = {
					page_size: 999,
					page_index: 1,
					is_recommend: 2
				};
				const {
					status,
					data
				} = await getTrainList(postData);
				if (status !== 200) return;
				this.trainList = data.result.data;
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().editUser()
						} else {
							this.network().addTrainRecommend()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addTrainRecommend: async () => {
						const {
							status,
							data
						} = await addTrainRecommend({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					editUser: async () => {
						const {
							status
						} = await editUser({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getUser: async (uuid) => {
						const {
							data,
							status
						} = await getUser({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.getTrainList()
				if (val.uuid) {
					this.isEdit = true;
					this.network().getUser(val.uuid)
				} else {
					this.addBody.identity = ''
					this.addBody.name = ''
					this.addBody.phone = ''
					this.addBody.account = ''
					this.addBody.password = ''
					this.addBody.uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>